import React from 'react';
import { compose } from 'ramda';
import classnames from 'classnames/bind';

import styleFile from './checkboxField.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withForm } from './';
import FormManager from './formManager';
import { withContent } from '../../providers/translateProvider';

export default compose(
  withForm(),
  PropertyManager(['form', 'formModel', 'validations', 'model', 'css', 'validationsFields', 'defaultValue', "formContext","transform", "parseModal","id", 'tabIndex', 'ariaLabel']),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(
  class CheckboxField extends React.Component {
    static displayName = 'CheckboxField';
    constructor(props) {
      super(props);

      const { form, id = '', model, defaultValue = false, validations = [], validationsFields, onChange, } = this.props.config;

      const subscription = {
        model: model,
        id: id,
        onChange: this.change,
        forceUpdate: this.forceUpdate,
        validations: validations,
        defaultValue: defaultValue,
        value: defaultValue,
        validationsFields: validationsFields,
        forceUpdateModel: !!this.props.config.formContext
      };

      if (this.props.config.formContext) {
        FormManager().addField(this.props.config.formContext, model, subscription);
      } else {
        form.subscribe(subscription);
      }


      this.state = {
        value: this.toModel(defaultValue)
      };
    }

    /*componentDidUpdate = () => {
      //this.subscribe();
    };*/

    componentDidMount = () => {
    };

    componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      const { form, model } = this.props.config;
      
      form.unSubscribe({ model: model });
    }

    toModel = (value)=>{
      if (this.props.config?.transform) {
        return this.props.config?.transform(value);
      } else {
        return value;
      }
    }

    onChange = event => {
      const value = !this.state.value;
      this.change(value);
    };

    parseModal = () =>{
      const value = !this.state.value;
      this.props.config.parseModal(value, this.change);
    }

    change = (value, preventCallback) => {

      const { config } = this.props;
      const { form, formModel } = config;
      if (!formModel.visited) {
        form.updateModel(config.model, { visited: true });
      }
      this.setState({ value: value }, () => {
        const { config } = this.props;
        config.form.onGlobalChange(config.model, this.toModel(value), preventCallback).then(() => {
          config.form.onGlobalBlur(config.model);
        });
      });
    };

    render = () => {
      const { value } = this.state;
      const { theme, config, content } = this.props;
      const { classes } = theme.styles;
      const { form, formModel, placeHolder, model, css, parseModal, id } = config;

      let cx = classnames.bind(classes);

      const handleKeyDown = (event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          parseModal ? this.parseModal() : this.onChange();
        }
      };

      let textLabel = config.ariaLabel;
      if (textLabel) {
        textLabel = content.t(textLabel);
      }

      return (
        (formModel && (
          <div
            className={[
              form.getValidClass(formModel, css, theme),
              theme.computedInnerStyle,
              cx({ checked: value })
            ].join(' ')}
            tabIndex={config.tabIndex}
            onKeyDown={handleKeyDown}
            aria-label={textLabel}>
            <input
              className={classes.visibilityHidden}
              value={value}
              onChange={parseModal ? this.parseModal : this.onChange}
              type={'checkbox'}
              name={model}
              placeholder={placeHolder}
              id={id}
            />
          </div>
        )) ||
        null
      );
    };
  }
);
